import { LayoutCards } from '@flatsy/core/Layout/Cards'
import { Body1 } from '@flatsy/core/MaterialUi/Typo'
import clsx from 'clsx'
import React, { useContext, useState, useEffect } from 'react'
import { useApplicantById } from 'src/hooks/ApplicantsSelector'
import { toNameCase } from '@flatsy/core/MaterialUi/Typo/Utile'
import { useSelector } from 'react-redux'
import { RootState } from 'src/redux'
import { Files, FilesKind, FilesMainKind } from '@flatsy/types/Files'
import { selectFilesByApplicant } from 'src/redux/slices/Files/Selector'
import { getProgressionForApplicant } from '@flatsy/utils/Functions/Files/GetApplicationDossierProgression'
import { APPLICANT_KIND } from '@flatsy/types/Applications/Applicant'
import { hasOneFileWithError } from '@flatsy/utils/Functions/Files/GetMainKindStatus'
import { useStyles } from './Style'
import { IApplicationItem } from './Type'
import Progress from './Progress'
import Action from './Action'
import { FileContext } from '../../../Context'

export interface formatedChildType {
  kind: FilesKind
  min: number
  file: Files[]
  valid: boolean
}

export interface formatedType {
  kind: FilesMainKind
  child: formatedChildType[]
  valid: boolean
  min: number
  count: number
}
const ApplicantsItems: React.FC<IApplicationItem> = ({ applicantId }): React.ReactElement => {
  const classes = useStyles()
  const {
    applicants: { currentId, setCurrent, list },
  } = useContext(FileContext)
  const applicant = useApplicantById(applicantId)
  const files = useSelector<RootState, Files[]>((state) =>
    selectFilesByApplicant(state, applicantId)
  )
  const isActive = currentId === applicantId
  const [progress, setProgress] = useState('0%')
  const [showAction, setShowAction] = useState(false)
  useEffect(() => {
    if (applicant && files) {
      const progression = getProgressionForApplicant({
        required_upload: applicant?.required_uploads,
        files,
      })
      const fileError = hasOneFileWithError({ files })
      setProgress(progression.percent)
      setShowAction(fileError)
    }
  }, [applicant, files])

  if (!applicant) {
    return <></>
  }

  const cardsClasses = () => {
    const classesArray = [classes.cards]
    if (isActive) {
      classesArray.push(classes.active)
    }
    return clsx(classesArray)
  }
  const sideComponents = () => {
    if (showAction) {
      return <Action />
    }

    return <Progress size={progress} />
  }

  const handleClick = () => {
    setCurrent(applicantId)
  }

  const getApplicantName = (): string => {
    if (!applicant.first_name || applicant.first_name === '') {
      if (applicant.kind === APPLICANT_KIND.guarantor) {
        if (applicant.applicant_id && list) {
          const find = list.find((singleApplicant) => applicant.applicant_id === singleApplicant.id)
          if (find) {
            return `Garant (${toNameCase(find.first_name)})`
          }
        }
        return 'Garant'
      }
      return 'Colocataire'
    }
    if (applicant.kind === APPLICANT_KIND.guarantor) {
      return `${toNameCase(applicant.first_name)} (garant)`
    }
    return toNameCase(applicant.first_name)
  }

  return (
    <LayoutCards strongShadow className={cardsClasses()} onClick={handleClick}>
      <Body1 className={clsx('applicantName', classes.name)}>{getApplicantName()}</Body1>
      {sideComponents()}
    </LayoutCards>
  )
}

export default ApplicantsItems
